import type { BillingInterval } from '@scio3/shared-types';
import { BillingCycleToggle } from '../../components/BillingCycleToggle';

type Props = {
  billingInterval: BillingInterval;
  onBillingIntervalChange: (value: BillingInterval) => void;
  monthlyPrice: number;
  yearlyPrice: number;
  yearlyFreeDevicePrice?: number;
  screenCount: number;
  currency?: string;
  showYearlyFreeDevice?: boolean;
  yearlyFreeDeviceDisabled?: boolean;
  monthlyDisabled?: boolean;
  yearlyDisabled?: boolean;
};

export function WizardStepPaymentTerm({
  billingInterval,
  onBillingIntervalChange,
  monthlyPrice,
  yearlyPrice,
  yearlyFreeDevicePrice,
  screenCount,
  currency,
  showYearlyFreeDevice,
  yearlyFreeDeviceDisabled,
  monthlyDisabled,
  yearlyDisabled,
}: Props) {
  return (
    <div className="py-4">
      <BillingCycleToggle
        value={billingInterval}
        onChange={onBillingIntervalChange}
        monthlyPricePerScreen={monthlyPrice}
        yearlyPricePerScreen={yearlyPrice}
        yearlyFreeDevicePricePerScreen={yearlyFreeDevicePrice}
        screenCount={screenCount}
        currency={currency}
        showYearlyFreeDevice={showYearlyFreeDevice}
        yearlyFreeDeviceDisabled={yearlyFreeDeviceDisabled}
        monthlyDisabled={monthlyDisabled}
        yearlyDisabled={yearlyDisabled}
      />
    </div>
  );
}
